import { FIELD_LABEL_TRANSLATION } from '../enums/ticket-event.enum';
import dayjs from 'dayjs';

// Format date (dùng dayjs)
const formatDateVN = (value: string): string => {
  const date = dayjs.utc(value).tz('Asia/Ho_Chi_Minh');
  return date.isValid() ? date.format('DD/MM/YYYY HH:mm') : value;
};

// Helper nhận message string
export const fieldTranslation = (message: string): string => {
  if (!message?.trim()) return '';

  try {
    const parsed = JSON.parse(message);
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
      const entries = Object.entries(parsed);
      if (entries.length === 0) return '';

      const [key, rawValue] = entries[0];
      const label = FIELD_LABEL_TRANSLATION[key] ?? key;

      let formattedValue: string;
      if (typeof rawValue === 'string' && /^\d{4}-\d{2}-\d{2}T/.test(rawValue)) {
        formattedValue = formatDateVN(rawValue);
      } else {
        formattedValue = String(rawValue);
      }

      return `${label}: ${formattedValue}`;
    }
  } catch {}

  return message.trim();
};
